import { HoneyloveWindow } from '../../models/HoneyloveWindow';

// okay to share with quiz tool?
export class GoogleAnalyticsService {
  public static instance: GoogleAnalyticsService = new GoogleAnalyticsService();

  private clientId: any;

  public async getClientId() {
    if (this.clientId) {
      return this.clientId;
    }

    try {
      /* tslint:disable-next-line */
      this.clientId = ((window as unknown) as HoneyloveWindow).ga.getAll()[0].get('clientId');
    } catch (error) {
      // do nothing
    }
    return this.clientId;
  }
}
